import { checkAndUpdateToken } from "./auth";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { buildDefaultHeaders } from "./helper";
import { createNotification } from "../components/notifications/notifications";
import * as types from './types';

// ============ AGGREGATED SETTINGS ============

export const getTvPanelSettings = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_TV_PANEL_SETTINGS_LOADING, payload: true });
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/tv_panel/settings`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: types.SET_TV_PANEL_SETTINGS, payload: data });
      dispatch({ type: types.SET_TV_PANEL_SS_FILES, payload: data.screensaver?.files || [] });
      dispatch({ type: types.SET_TV_PANEL_SS_SETTINGS, payload: {
        idle_sec: data.screensaver?.idle_sec ?? 300,
        slide_sec: data.screensaver?.slide_sec ?? 10
      }});
    } else {
      createNotification('error', 'Ошибка загрузки настроек ТВ-панели');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_SETTINGS_LOADING, payload: false });
  }
};

// ============ BACKGROUND ============

export const uploadTvPanelBackground = (file) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  const formData = new FormData();
  formData.append("file", file);

  dispatch({ type: types.SET_TV_PANEL_BG_UPLOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/background`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`
      },
      body: formData
    });
    if (response.ok) {
      createNotification('success', 'Фон загружен');
      dispatch(getTvPanelSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка загрузки фона');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_BG_UPLOADING, payload: false });
  }
};

export const deleteTvPanelBackground = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/background`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Фон удалён');
      dispatch(getTvPanelSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка удаления фона');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

// ============ EMBLEM ============

export const uploadTvPanelEmblem = (file) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  const formData = new FormData();
  formData.append("file", file);

  dispatch({ type: types.SET_TV_PANEL_EMBLEM_UPLOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/emblem`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`
      },
      body: formData
    });
    if (response.ok) {
      createNotification('success', 'Знак загружен');
      dispatch(getTvPanelSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка загрузки знака');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_EMBLEM_UPLOADING, payload: false });
  }
};

export const deleteTvPanelEmblem = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/emblem`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Знак удалён');
      dispatch(getTvPanelSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка удаления знака');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

export const setTvPanelEmblemVisibility = (enabled) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/emblem/visibility`, {
      method: "PUT",
      body: JSON.stringify({ enabled }),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch(getTvPanelSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка обновления настройки');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

// ============ SCREENSAVER FILES ============

export const getTvPanelSsFiles = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_TV_PANEL_SS_FILES_LOADING, payload: true });
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/tv_panel/screensaver/files`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: types.SET_TV_PANEL_SS_FILES, payload: data });
    } else {
      createNotification('error', 'Ошибка загрузки файлов заставки');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_SS_FILES_LOADING, payload: false });
  }
};

export const uploadTvPanelSsFiles = (files) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  const formData = new FormData();
  files.forEach(file => formData.append("file", file));

  dispatch({ type: types.SET_TV_PANEL_SS_FILE_UPLOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/screensaver/files`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`
      },
      body: formData
    });
    if (response.ok) {
      createNotification('success', 'Файлы загружены');
      dispatch(getTvPanelSsFiles());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка загрузки файлов');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_SS_FILE_UPLOADING, payload: false });
  }
};

export const deleteTvPanelSsFile = (fileId) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_TV_PANEL_SS_FILES_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/screensaver/files/${fileId}`, {
      method: "DELETE",
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Файл удалён');
      dispatch(getTvPanelSsFiles());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка удаления');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_SS_FILES_LOADING, payload: false });
  }
};

export const updateTvPanelSsFile = (fileId, data) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/screensaver/files/${fileId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch(getTvPanelSsFiles());
    } else {
      const result = await response.json();
      createNotification('error', result.error || 'Ошибка обновления');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

export const updateTvPanelSsFilesOrder = (files) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/screensaver/files/order`, {
      method: "PUT",
      body: JSON.stringify(files),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      dispatch(getTvPanelSsFiles());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка сохранения порядка');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  }
};

// ============ SCREENSAVER SETTINGS ============

export const getTvPanelSsSettings = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_TV_PANEL_SS_SETTINGS_LOADING, payload: true });
  try {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/tv_panel/screensaver/settings`,
      buildDefaultHeaders(getState)
    );
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: types.SET_TV_PANEL_SS_SETTINGS, payload: data });
    } else {
      createNotification('error', 'Ошибка загрузки настроек заставки');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_SS_SETTINGS_LOADING, payload: false });
  }
};

export const saveTvPanelSsSettings = (settings) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (!getState().auth.token) return;

  dispatch({ type: types.SET_TV_PANEL_SS_SETTINGS_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/tv_panel/screensaver/settings`, {
      method: "PUT",
      body: JSON.stringify(settings),
      ...buildDefaultHeaders(getState)
    });
    if (response.ok) {
      createNotification('success', 'Настройки заставки сохранены');
      dispatch(getTvPanelSsSettings());
    } else {
      const data = await response.json();
      createNotification('error', data.error || 'Ошибка сохранения настроек');
    }
  } catch (err) {
    createNotification('error', 'Ошибка сети');
  } finally {
    dispatch({ type: types.SET_TV_PANEL_SS_SETTINGS_LOADING, payload: false });
  }
};
